import { useEffect } from "react"
import { appPanelUpdate } from "../appPanelSlice"
import { useAppDispatch } from "."
import type { EventRouter } from "../../components/messaging/types"

export const useAppPanelEffect = (appPanelEvent: EventRouter<void>): void => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        const dispatchAppPanel = () => {
            dispatch(appPanelUpdate())
        }

        appPanelEvent.listen(dispatchAppPanel)
        return () => appPanelEvent.removeListener(dispatchAppPanel)
    }, [dispatch, appPanelEvent])
}
